import React from "react";
import "./createAgent.scss";
import AgentModal from "./agentModal";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RenovateBox from "./renovateBox";
import NeedHelp from "../../needHelp";
import uploadIcon from "../../../assets/icons/upload.svg";
import ScratchScript from "./scratchScript";
import BuildNewScript from "./BuildNewScript";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateAgent = () => {
  var value = localStorage.getItem("name");
  if (value && value != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }
  const [showComponent, setShowComponent] = useState(false);

  const handleAnchorClick = () => {
    setShowComponent(true);
  };

  const [activeFilter, setActiveFilter] = useState("First");
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const [showScript, setShowScript] = useState(true);
  const[type, settype] = useState("")
  const handleShowScript = () => {
    setShowScript(false);
    
    console.log("i am here what are you doing ");
  };

  const [showReno, setShowReno] = useState(true);
  const handleShowReno = () => {
    setShowReno(false);
  };

  const [showScratch, setShowScratch] = useState(true);
  const handleShowScratch = () => {
    setShowScratch(false);
  };

  const [show, setShow] = useState(false);
  const [showmodal2, setShowmodal2] = useState(false);
  const [showmodal3, setShowmodal3] = useState(false);
  const [showmodal4, setShowmodal4] = useState(false);
  const [showmodal5, setShowmodal5] = useState(false);
  const [showmodal6, setShowmodal6] = useState(false);

  const handleClose = () => setShow(false);
  const handleClose2 = () => setShowmodal2(false);
  const handleClose3 = () => setShowmodal3(false);
  const handleClose4 = () => setShowmodal4(false);
  const handleClose5 = () => setShowmodal5(false);
  const handleClose6 = () => setShowmodal6(false);

  const handleShow = () => setShow(true);
  const handleShowmodal2 = () => setShowmodal2(true);
  const handleShowmodal3 = () => setShowmodal3(true);
  const handleShowmodal4 = () => setShowmodal4(true);
  const handleShowmodal5 = () => setShowmodal5(true);
  const handleShowmodal6 = () => setShowmodal6(true);

  const [isClicked, setIsClicked] = useState(false);
  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      // handleFiles(e.dataTransfer.files);
    }
  };
  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // at least one file has been selected so do something
      // handleFiles(e.target.files);
    }
  };
  // ------------------------------------------------------------------
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  const navigate = useNavigate();

  const [agent, setAgent] = useState(null);
  const [agentPromptType, setAgentPromptType] = useState("");

  const [selectedElement, setSelectedElement] = useState(null);
  const [agentName, setAgentName] = useState();
  const [userId, setUserId] = useState();
  const [enteredName, setEnteredName] = useState("");
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [nameError, setNameError] = useState("");
  const [promptType, setPromptType] = useState();
  const [loading, setLoading] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [fileGenerated, setFileGenerated] = useState();

  const handlesetAgentName = async (value) => {};

  const handlePromptType = (value) => {
    console.log(value,"promttype");
    setAgentPromptType(value);
    setSelectedElement(value);
  };

  const handleSubmit = () => {
    console.log(enteredName, "enteredName.length");

    if (enteredName) {
      console.log("Entere");
      setUser(enteredName);
      setEnteredName("");
      setError(null);
    } else {
      console.log("else Entere");
      setNameError("Please enter a name");
    }
  };

  const HandleCreateAgent = async () => {
    try {
      console.log(agentPromptType, "agentPromptType");
      console.log(agentName, "agentName");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer/agent`,
        {
          promptType: agentPromptType,
          agentName,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log(response.data._id, "data======");
      setUserId(response.data._id);
      setAgent(response.data);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleUploadResponse = async (url, fileType) => {
    try {
      setLoading(true);
      let data = {
        file: url,
        fileType: fileType,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/customer/transcribe/${userId}`,
        // url: `http://localhost:8000/customer/transcribe/${userId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log("inside functtion", url);
          console.log(JSON.stringify(response.data));

          //display back prompt
          if (response.data) {
            const GeneratedResponse = response.data;

            console.log("Responce From Gpt :", GeneratedResponse);

            setFileGenerated(GeneratedResponse);
            setFileModal(false); // gpt response modal
            // setGptCloneModal(true); // gpt response modal
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("Here");
          setLoading(false);

          console.log(error);
        });
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Corrected 'terget' to 'target'
    const fileFolderPath = "Document";
    console.log("file: ", file);
    if (file) {
      UploadFileToS3(file, fileFolderPath)
        .then((result) => {
          console.log("Upload successful:", result);
          handleUploadResponse(result.file_url, file.type);
        })
        .catch((error) => {
          console.error("Upload failed:", error);
        });
    } else {
      console.error("No file selected.");
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const UploadFileToS3 = async (file, fileFolderPath) => {
    const convertedFile = await convertToBase64(file);
    console.log("file",fileFolderPath);
    return new Promise(async (resolve, reject) => {
      try {
        //Url set in the server. Server will return s3 object download url
        let url = `${process.env.REACT_APP_API_URL}/customer/aws-Fileupload`;
        // setLoading(true);
        axios
          .post(
            url,
            {
              file: convertedFile,
              fileFolderPath: fileFolderPath,
              fileName: file.name,
              fileType: file.type,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
          .then((response) => {
            console.log("response", response);
            if (response.data.success == true) {
              console.log(
                "response.data.thumbnail_url",
                response.data.file_url
              );
              if (response.data.file_url) {
                const myUrl = response.data.file_url;
                console.log(" url", myUrl);
              }
              resolve({
                success: true,
                file_url: response.data.file_url,
              });
            } else {
              reject({ success: false, error: response.data.error });
            }
          })
          .catch((err) => {
            console.log(err);
            reject({ success: false, error: err });
          });
      } catch (error) {
        console.log(error);
        reject({ success: false, error });
      }
    });
  };

  const Logout = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("phone");
      localStorage.removeItem("name");

      authToken = null;
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  ////////////////////////////////////
  const [agentNameCheck, setagentNameCheck] = useState("");
  const handleSaveClick = async () => {
    if (agentNameCheck === "") {
      toast.error("Input field cannot be empty");
    } else {
      await HandleCreateAgent();
      handleShowmodal2();
      handleClose();
    }
  };
  ////////////////////////////////////

  return (
    <>
      {showScript ? (
        <div className="create-agent-wrapper">
          <div className="topBar">
            <div className="bruceDiv">
              <img
                className="bruceImg"
                src="/images/Dashboard/bruceImg.png"
                alt="..."
              />
              <h3>{name}</h3>
            </div>

            <div className="login-btn" onClick={Logout}>
              <button>Logout</button>
            </div>
          </div>

          <div className="needHelpDiv">
            <a href="/needHelp">Need Help?</a>
          </div>
          {showReno && showScratch ? (
            <div>
              <h2 className="agent-head mb-1">Agents</h2>
              <p className="agent-para">Create your own customized agent</p>
              {/* <button onClick={<AgentModal/>} className='agent-btn'>Create your own Agent</button> */}

              {/* New Agent Code */}
              <div className="pr-4">
                <Button className="agent-btn" onClick={handleShow}>
                  Create your own Agent
                </Button>
              </div>

              <Modal show={show} onHide={handleClose} className="agentModal">
                <Modal.Header closeButton>
                  <Modal.Title className="titleOfModal">
                    Create New Agents
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body className="modalBody">
                  <h3>Name</h3>
                  <input
                    type="search"
                    placeholder="Enter your Agent Name"
                    onChange={(e) => {
                      setAgentName(e.target.value);
                      setagentNameCheck(e.target.value);
                      // console.log('Input value:', agentNameCheck);
                    }}
                  />
                  <h3>Choose your use case</h3>

                  <div
                    className={`choosingCase ${
                      selectedElement === "Concrete Restoration"
                        ? "selected"
                        : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Concrete Restoration");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Concrete Restoration</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Stucco Repair" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Stucco Repair");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Stucco Repair</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Painting" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Painting");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Painting</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Roofing" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Roofing");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Roofing</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Waterproofing" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Waterproofing");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Waterproofing</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Pool Renovation & Restoration"
                        ? "selected"
                        : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Pool Renovation & Restoration");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Pool Renovation & Restoration</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Pavers and Landscaping"
                        ? "selected"
                        : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Pavers and Landscaping");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Pavers and Landscaping</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Dock & Deck" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Dock & Deck");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Dock & Deck</p>
                  </div>
                  <div
                    className={`choosingCase ${
                      selectedElement === "Seawalls" ? "selected" : ""
                    }`}
                    onClick={(e, value) => {
                      handleSubmit();
                      handlePromptType("Seawalls");
                      handlesetAgentName(e.target.value);
                    }}
                  >
                    <p>Seawalls</p>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    onClick={
                      handleSaveClick
                      //   async () => {
                      //   await HandleCreateAgent();
                      //   handleClose2 && handleClose();
                      //   handleShowmodal2 && handleShowmodal2();
                      //   handleSaveClick();
                      // }
                    }
                    className="save-btn"
                  >
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* New Agent Code */}

              {/* Creating Script Code (Magical or scratch) */}
              <Modal
                show={showmodal2}
                onHide={() => {
                  handleClose2 && handleClose2();
                  handleShow && handleShow();
                }}
                className="agentModal2"
              >
                <Modal.Header closeButton></Modal.Header>

                <Modal.Body className="modalBody">
                  <h4>
                    How do you want to create a script for your agent to follow?
                  </h4>
                  <div className="creating-script-box">
                    <div
                      onClick={() => {
                        settype("1")
                        handleClose3 && handleClose2();
                        handleShowmodal3 && handleShowmodal3();
                        handleShowScript();
                      }}
                      className="magicalBox"
                    >
                      <p>Magically Generate Using AI</p>
                      <span>
                        Have AI magically create a script by uploading a call
                        recording, pasting in your script, or let Landav AI ask
                        you a few you qestions to get context.
                      </span>
                    </div>
                    <div
                      className="creatingScratchBox"
                      onClick=
                      {() => {
                        settype("2")
                        handleClose3 && handleClose2();
                        handleClose3 && handleClose3();
                        handleShowScript();
                        }}
                    >
                      <p>Create from Scratch </p>
                      <span>
                        Start with a fresh blank state and create a script from
                        scratch.
                      </span>
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  {/* <Button
                    onClick={() => {
                      handleClose3 && handleClose2();
                      handleShowmodal3 && handleShowmodal3();
                    }}
                    className="script-btn"
                  >
                    Choose script creation type
                  </Button> */}
                </Modal.Footer>
              </Modal>
              {/* Creating Script Code */}

              {/* Magically Generating Script Code */}
              <Modal
                show={showmodal3}
                onHide={() => {
                  handleClose3 && handleClose3();
                  handleShowmodal2 && handleShowmodal2();
                }}
                className="agentModal3"
              >
                <Modal.Header closeButton></Modal.Header>

                <Modal.Body className="modalBody">
                  <h4>How do you want to magically generate a script?</h4>
                  <div className="magicalGeneratingMainBox">
                    <div
                      onClick={() => {
                       
                        handleClose3 && handleClose3();
                        handleShowmodal4 && handleShowmodal4();
                      }}
                      className="callRecordingDiv"
                    >
                      <h5>Upload a call recording </h5>
                      <p>Clone your best rep by uploading a call recording.</p>
                    </div>

                    <div
                      onClick={() => {
                        handleClose3 && handleClose3();
                        handleShowmodal5 && handleShowmodal5();
                      }}
                      className="callRecordingDiv"
                    >
                      <h5>Give Group Landev AI you existing script</h5>
                      <p>
                        Copy & paste your current script and let AI reformat it
                        an a way that is easy for your agent to follow.
                      </p>
                    </div>

                    <div
                      onClick={() => {
                        handleClose3 && handleClose3();
                        handleShowmodal6 && handleShowmodal6();
                      }}
                      className="callRecordingDiv"
                    >
                      <h5>Use a proven template from AI</h5>
                      <p>
                        Select a proven template, give AI some basic context,
                        and have AI customize it for your business
                      </p>
                    </div>
                  </div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    onClick={() => {
                      handleClose3 && handleClose3();
                      handleShowmodal4 && handleShowmodal4();
                    }}
                    className="script-btn"
                  >
                    Select Magic Generation Type
                  </Button>
                </Modal.Footer>
              </Modal>
              {/* Magically Generating Script Code */}

              {/*Upload Your Call Code */}
              <Modal
                show={showmodal4}
                onHide={() => {
                  handleClose4 && handleClose4();
                  handleShowmodal3 && handleShowmodal3();
                }}
                className="agentModal4"
              >
                <Modal.Header closeButton></Modal.Header>

                <Modal.Body className="modalBody">
                  <h4>Upload a Call Recording</h4>
                  <p className="callRpara">
                    Clone your best rep by uploading a call recording from them
                    and we'll magically create a script for your Group Landev
                    Agent to follow based on it.
                  </p>
                  <section id="form-file-upload">
                    <input
                      type="file"
                      id="input-file-upload"
                      onChange={handleFileChange}
                    />
                    <label id="label-file-upload" htmlFor="input-file-upload">
                      <div>
                        <img className="mb-3" src={uploadIcon} alt="" />
                        <p className="upload-text">
                          Click to upload files from computer
                        </p>
                        <p className="upload-text2">or drag and drop here</p>
                      </div>
                    </label>
                  </section>
                </Modal.Body>
              </Modal>

              {/*Upload Your Call Code */}

              {/*Upload Your Script Code */}
              <Modal
                show={showmodal5}
                onHide={() => {
                  handleClose5 && handleClose5();
                  handleShowmodal3 && handleShowmodal3();
                }}
                className="agentModal5"
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="modalBody">
                  <h4>Upload Your Script</h4>
                  <p className="callRpara">
                    Upload your script and we'll automatically clean it up to
                    make it much easier for your Air Agent to understand and
                    follow.
                  </p>
                  <textarea
                    className="script-text"
                    type="text"
                    placeholder="Copy and paste your original script here that you want to clean up..."
                  ></textarea>
                </Modal.Body>
                <Modal.Footer>
                  <Button className="script-btn">New Step</Button>
                </Modal.Footer>
              </Modal>
              {/*Upload Your Script Code */}
              {/* Proven Template Code */}
              <Modal
                show={showmodal6}
                onHide={() => {
                  handleClose6 && handleClose6();
                  handleShowmodal3 && handleShowmodal3();
                }}
                className="agentModal6"
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="modalBody">
                  <div className="templateMainWrapper">
                    <div className="templateLeftContent">
                      <h5>Templates</h5>
                      <p onClick={() => handleFilterClick("First")}>
                        Abandon cart
                      </p>
                      <p onClick={() => handleFilterClick("Second")}>
                        Pain/Desire Gap
                      </p>
                      <p>One Word Script</p>
                      <p>Customer Service Script</p>
                      <p>Abandon cart</p>
                      <p>Abandon cart</p>
                      <p>Abandon cart</p>
                    </div>
                    <div className="templateRightContent">
                      {activeFilter === "First" ? (
                        <div className="abandonCartContent">
                          <h5 className="text-center">
                            Preview of selected script
                          </h5>
                          <p>
                            “Hey,
                            <br />
                            !” “My name is Alexander and I’m customer support
                            specialist at [company]” <br />
                            “I hope this is not a bad time, I’m just calling to
                            thank you for visiting our store and ask for some
                            feedback since we’re trying to grow the business and
                            would love to get feedback from a fresh pair of
                            eyes.” <br />
                            “How did you hear about us?” <br />
                            “Was the site easy to use, and did you find what you
                            were looking for?”
                            <br />
                            “I saw you were interested in [insert product they
                            had in their cart here], what interested you about
                            this, and what caused you to leave us before
                            confirming your purchase?” <br />
                            “Do you have any unanswered questions or concerns
                            about the product?” <br />
                            “Thank you for your feedback and your time. If you
                            are still interested, I can send you a 10% discount
                            code.” <br />
                            “Ok, I can just send that over right now. And if you
                            do end up using that discount code, thanks in
                            advance! All support is greatly appreciated.”
                          </p>
                        </div>
                      ) : activeFilter === "Second" ? (
                        <div className="painDesireContent">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Assumenda, rem, dolores eos nobis autem fuga
                          reiciendis ea asperiores iste ad ex alias enim aut
                          cupiditate id sint doloribus maxime. Corrupti!
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <h2 className="agent-head mb-1">Built-in Agents</h2>
              <p className="agent-para">Helps to Build with you</p>
              <div className="renovatopnBoxesDiv">
                <div className="renovate-agent-btn" onClick={handleShowReno}>
                  <p>Renovate your Construction</p>
                  <span>
                    5 different agents you can call with and chat also
                  </span>
                </div>

                <div className="build-agent-btn" onClick={handleShowScratch}>
                  <p>Build From Scratch</p>
                  <span>
                    4 different agents you can call with and chat also
                  </span>
                </div>
              </div>
            </div>
          ) : showScratch ? (
            <RenovateBox />
          ) : (
            <BuildNewScript />
          )}
        </div>
      ) : (
        <ScratchScript
          userId={userId}
          agentData={agent}
          agentPromptType={agentPromptType}
          type={type}
        />
      )}
    </>
  );
};

export default CreateAgent;
